import { PencilIcon } from "@heroicons/react/24/solid";

export default function UserProfileCard({ userData, tab, setTab }) {
  return (
    <div className="bg-white rounded-2xl shadow p-4 top-8">
      <div className="flex flex-col items-center text-center">
        <div className="relative w-24 h-24">
          <img
            src={userData?.photo_url || "https://via.placeholder.com/150"}
            alt="profile"
            className="w-24 h-24 rounded-full border object-cover"
          />

          {/* Edit Icon Overlay */}
          {/* <button
            className="absolute top-0 right-0 bg-white border border-gray-300 rounded-full p-1 shadow-md hover:bg-gray-100 transition"
            aria-label="Edit profile picture"
          >
            <PencilIcon className="w-4 h-4 text-gray-600" />
          </button> */}
        </div>

        <h2 className="text-lg font-semibold mt-2">{userData?.handleName || "Guest"}</h2>
        <p className="text-gray-500 text-sm">{userData?.points || 0} credit(s)</p>

        {/* {userData?.aboutme ? (
          <p className="mt-2 text-sm text-gray-600">
            {userData.aboutme.length > 80
              ? `${userData.aboutme.slice(0, 80)}…`
              : userData.aboutme}
            <span className="text-blue-500 ml-1">See more</span>
          </p>
        ) : (
          <button className="mt-2 px-4 py-2 border border-gray-300 text-gray-600 text-sm rounded-lg hover:bg-gray-100 transition">
            Edit About Me
          </button>
        )} */}

        {/* Tabs */}
        <div className="hidden sm:flex flex-wrap gap-2 mt-3 justify-center">
          {["Forms"].map((item) => (
            <button
              key={item}
              onClick={() => setTab(item)}
              className={`px-4 py-1 rounded-full text-sm ${tab === item ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700"
                }`}
            >
              {item}
            </button>
          ))}
          {["Membership"].map((item) => (
            <button
              key={item}
              onClick={() => setTab(item)}
              className={`px-4 py-1 rounded-full text-sm ${tab === item ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700"
                }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
